import { render, staticRenderFns } from "./BulkTrafficDecisionPanel.vue?vue&type=template&id=18368855&scoped=true"
import script from "./BulkTrafficDecisionPanel.vue?vue&type=script&lang=js"
export * from "./BulkTrafficDecisionPanel.vue?vue&type=script&lang=js"
import style0 from "./BulkTrafficDecisionPanel.vue?vue&type=style&index=0&id=18368855&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18368855",
  null
  
)

export default component.exports